export enum SourceEnum {
  DOPUNSKO = 'newDZOfunnel',
  DODATNO = 'newDodatnoFunnel'
}
